<template>
  <div>
    <container navWidth="380" detailWidth="380">
      <template v-slot:nav="{height}">
        <alert v-if="!$tools.isEmpty(notif)" block @close="notif=null" class="blinkWarning">
          {{notif}}
        </alert>
        <chat-search @search="(v)=>search=v"/>
        <v-divider/>
        <div v-if="getSearchPhones().length>0">
          <alert>Чат не найден<br/>нажмите на номер телефона<br/>что бы создать с ним чат</alert>
          <div v-for="(v, k) in getSearchPhones()" :key="k" class="text-center">
            <v-btn depressed small @click="chatCreate(v)">{{$tools.phoneFormat(v)}}</v-btn>
          </div>
        </div>
        <div v-show="getSearchPhones().length===0">
          <v-row no-gutters>
            <v-col>
              <v-tabs v-model="tabPublic" background-color="transparent" fixed-tabs height="54px">
                <v-tab @click="$tools.storageSet('chatsTabPublic', 0)" class="pa-0">
                  <v-row no-gutters>
                    <v-col cols="12">
                      <v-progress-circular v-if="queueState.data.count===0 && queueState.loading" indeterminate color="primary" size="18" style="margin-top: 3px;margin-bottom: 2px" width="2"/>
                      <span v-else-if="queueState.data.count===0" class="text-no-wrap"><v-icon>mdi-account-question</v-icon></span>
                      <v-badge v-else-if="queueState.data.count>0" :content="queueState.data.count" class="pt-1" inline/>
                    </v-col>
                    <v-col cols="12" class="caption text-no-wrap" style="font-size: 10px !important;">Очередь</v-col>
                  </v-row>
                </v-tab>
                <v-tab @click="$tools.storageSet('chatsTabPublic', 1)" class="pa-0">
                  <v-row no-gutters>
                    <v-col cols="12">
                      <v-progress-circular v-if="processState.data.count===0 && processState.loading" indeterminate color="primary" size="18" style="margin-top: 3px;margin-bottom: 2px" width="2"/>
                      <span v-else-if="processState.data.count===0" class="text-no-wrap"><v-icon>mdi-account-clock</v-icon></span>
                      <v-badge v-else-if="processState.data.count>0" :content="processState.data.count" class="pt-1" inline/>
                    </v-col>
                    <v-col cols="12" class="caption text-no-wrap" style="font-size: 10px !important;">Обработка</v-col>
                  </v-row>
                </v-tab>
                <v-tab @click="$tools.storageSet('chatsTabPublic', 2)" class="pa-0">
                  <v-row no-gutters>
                    <v-col v-if="$tools.isEmpty(search)" cols="12">
                      <v-progress-circular v-if="closedState.loading" indeterminate color="primary" size="18" style="margin-top: 3px;margin-bottom: 2px" width="2"/>
                      <span v-else class="text-no-wrap"><v-icon>mdi-account-remove</v-icon></span>
                    </v-col>
                    <v-col v-else cols="12">
                      <v-progress-circular v-if="closedState.loading" indeterminate color="primary" size="18" style="margin-top: 3px;margin-bottom: 2px" width="2"/>
                      <span v-else-if="closedState.data.count===0" class="text-no-wrap"><v-icon>mdi-account-remove</v-icon></span>
                      <v-badge v-else-if="closedState.data.count>0" :content="closedState.data.count" class="pt-1" inline/>
                    </v-col>
                    <v-col cols="12" class="caption text-no-wrap" style="font-size: 10px !important;">Закрытые</v-col>
                  </v-row>
                </v-tab>
              </v-tabs>
            </v-col>
            <v-col cols="auto" align-self="center">
              <v-menu offset-y right :close-on-content-click="false">
                <template v-slot:activator="{ attrs, on }">
                  <v-btn v-bind="attrs" v-on="on" icon class="mx-1"><v-icon>mdi-dots-vertical</v-icon></v-btn>
                </template>
                <div class="caption py-2 px-4">Просмотр</div>
                <radios
                    :select.sync="filterView"
                    :items="[{id:'my',name:'Мои чаты'},{id:'all',name:'Чаты всех пользователей'}]"
                    class="mb-0"
                />
                <div class="caption py-2 px-4">Сортировка</div>
                <radios
                    :select.sync="filterSort"
                    :items="[{id:'priority',name:'По приоритету'}, {id:'time',name:'По времени'}]"
                    class="mb-0"
                />
              </v-menu>
            </v-col>
          </v-row>
          <v-divider/>
          <div v-show="tabPublic===0">
            <chats-list
                key="queue"
                ref="queue"
                :height="height-48-54-1-1"
                type="queue"
                :chat.sync="chat"
                :search="search"
                @state="v=>queueState=v"
                :filterView="filterView"
                :filterSort="filterSort"
            />
          </div>
          <div v-show="tabPublic===1">
            <chats-list
                key="process"
                ref="process"
                :height="height-48-54-1-1"
                type="process"
                :chat.sync="chat"
                :search="search"
                @state="v=>processState=v"
                :filterView="filterView"
                :filterSort="filterSort"
            />
          </div>
          <div v-show="tabPublic===2">
            <chats-list
                key="closed"
                ref="closed"
                :height="height-48-54-1-1"
                type="closed"
                :chat.sync="chat"
                :search="search"
                @state="v=>closedState=v"
                :filterView="filterView"
                :filterSort="filterSort"
            />
          </div>
        </div>

      </template>
      <template v-slot:content="{height}">
        <chat
            key="chat"
            ref="chat"
            :chat="chat"
            :height="height"
            @close="chat=null"
            @toClient="toClient"
            :messageTemplates="messageTemplates"
            :messageTemplatesComponent="$refs.chatsMessageTemplates"
            :filterView="filterView"
            @update:comContact="(v)=>comContact=v"
        />
      </template>
      <template v-slot:detail="{height}">
        <chats-message-templates
            ref="chatsMessageTemplates"
            :height="height"
            :items.sync="messageTemplates"
            :chat="chat"
            :selectAllowed="chat!==null"
            :userClientId="chat?.info.userClient.userId"
            :comContact="comContact"
            @select="(v)=>$refs.chat.messageTemplateSelect(v)"
        />
      </template>
    </container>
  </div>
</template>

<script>
import Container from "../../../componentsV2/base/Container.vue";
import ChatsList from "./components/ChatsList.vue";
import ChatsMessageTemplates from "./components/ChatsMessageTemplates.vue";
import ChatSearch from "./components/ChatSearch.vue";
import Chat from "./components/Chat.vue";
import axios from "axios";
import Api from "../../../Api";
import Alert from "../../../componentsV2/base/Alert.vue";
import Radios from "@/componentsV2/base/Radios.vue";
import Stater from "@/plugins/stater";

export default {
  components: {Radios, Alert, Chat, ChatSearch, ChatsMessageTemplates, ChatsList, Container},
  props: [],
  data: () => ({
    tabPublic:0,
    search:null,
    filterView:null,
    filterSort:null,

    queueState:new Stater({items:[],count:0}),
    processState:new Stater({items:[],count:0}),
    closedState:new Stater({items:[],count:0}),

    chat:null,
    comContact:null,
    messageTemplates: [],

    subscribeListenerId:null,
    notif:null,
  }),
  mounted() {
    this.tabPublic = parseInt(this.$tools.storageGet('chatsTabPublic', 0));
    this.$ws.connectWithSubscribeListener(this.$store.state.user, (v)=>this.subscribeListenerId=v, (m)=>{
      if(m.type==='messengerSettingsNotif'){
        this.notif = null;
        this.$tools.debounce(()=>{
          this.notif = m.data.text;
        }, 100, 'messengerSettingsNotif')
      }
    });
    this.filterView = this.$tools.storageGet('contactCenter_filterView', {id:'my',name:'Мои чаты'})
    this.filterSort = this.$tools.storageGet('contactCenter_filterSort', {id:'priority',name:'По приоритету'})
  },
  watch:{
    queueCount(){
      this.$emit('count', this.queueCount+this.processCount)
    },
    processCount(){
      this.$emit('count', this.queueCount+this.processCount)
    },
    filterView(){
      this.$tools.storageSet('contactCenter_filterView', this.filterView)
    },
    filterSort(){
      this.$tools.storageSet('contactCenter_filterSort', this.filterSort)
    }
  },
  beforeDestroy() {
    this.$ws.removeSubscribeListener(this.subscribeListenerId);
  },
  methods:{
    toClient(){
      axios.post(Api.host+'/messenger/chat/'+this.chat.id+'/toClient/').then((r)=>{
        this.tabPublic = 1;
        this.$tools.storageGet('chatsTabPublic', this.tabPublic)
        this.chat = r.data;
        this.$refs.queue.load();
        this.$refs.process.load();
        this.$refs.closed.load();
      }).catch(()=>{
        this.chat = null;
        this.$refs.queue.load();
        this.$refs.process.load();
        this.$refs.closed.load();
      });
    },
    getSearchPhones(){
      if(this.$tools.isEmpty(this.search))
        return [];

      if(
          this.queueState.success && this.queueState.data.count===0 &&
          this.processState.success && this.processState.data.count===0 &&
          this.closedState.success && this.closedState.data.count===0
      ){
        return this.$tools.phonesSearch(this.search);
      }

      return [];
    },
    chatCreate(phone){
      axios.post(Api.host+'/messenger/chat/fromPhone/', {
          phone:phone
        }).then(()=>{
          this.search = null;
          this.tabPublic = 1;
          this.$tools.storageSet('chatsTabPublic', 1)
        }).catch(() =>{
          this.search = null;
          this.tabPublic = 1;
          this.$tools.storageSet('chatsTabPublic', 1)
        });
    }
  }
}
</script>